import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CloudProvider } from '../../core/cloud-catalog';

/**
 * Cloud provider selector (AWS / Azure / GCP). Provider-aware and functional:
 * the active provider is highlighted and selecting one emits `providerChange` so
 * the Cloud overview can switch scope. All providers are first-class; the parent
 * decides what an unconnected provider shows (a connect empty-state).
 */
@Component({
  selector: 'app-provider-switcher',
  template: `
    <div class="flex w-fit items-center gap-0.5 rounded-lg border border-slate-200 bg-slate-50 p-0.5" role="tablist" aria-label="Cloud provider">
      <button
        type="button"
        class="flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-medium transition-colors"
        [class.bg-slate-900]="active === 'AWS'"
        [class.text-white]="active === 'AWS'"
        [class.text-slate-500]="active !== 'AWS'"
        role="tab" [attr.aria-selected]="active === 'AWS'" aria-label="AWS"
        (click)="select('AWS')"
      >
        <lucide-icon name="cloud" [size]="13" [strokeWidth]="2"></lucide-icon>
        AWS
      </button>
      <button
        type="button"
        class="flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-medium transition-colors"
        [class.bg-slate-900]="active === 'AZURE'"
        [class.text-white]="active === 'AZURE'"
        [class.text-slate-500]="active !== 'AZURE'"
        role="tab" [attr.aria-selected]="active === 'AZURE'" aria-label="Azure"
        (click)="select('AZURE')"
      >
        <lucide-icon name="cloud" [size]="13" [strokeWidth]="2"></lucide-icon>
        Azure
      </button>
      <button
        type="button"
        class="flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-medium transition-colors"
        [class.bg-slate-900]="active === 'GCP'"
        [class.text-white]="active === 'GCP'"
        [class.text-slate-500]="active !== 'GCP'"
        role="tab" [attr.aria-selected]="active === 'GCP'" aria-label="GCP"
        (click)="select('GCP')"
      >
        <lucide-icon name="cloud" [size]="13" [strokeWidth]="2"></lucide-icon>
        GCP
      </button>
    </div>
  `,
})
export class ProviderSwitcherComponent {
  @Input() active: CloudProvider = 'AWS';
  @Output() providerChange = new EventEmitter<CloudProvider>();

  select(provider: CloudProvider): void {
    if (provider !== this.active) this.providerChange.emit(provider);
  }
}
